<template>
  <div class="addSupplyChain main-content">
    <!-- 顶部菜单 -->
    <!-- <div class="topData">
      <base-form 
        v-model="topData"
        :options="options"
        ref="topData" 
        :rules="topDataRules" 
        @input="handleChangeTopData"
        label-width="100px">
      </base-form>
    </div> -->
    <div class="topData">
      <el-form :model="topData" :rules="topDataRules" ref="topData" label-width="100px">
        <el-row :gutter="24">
          <!-- 公司code -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyCode')" prop="companyCode">
              <el-input disabled v-model="topData.companyCode"></el-input>
            </el-form-item>
          </el-col>
          <!-- 公司名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyName')" prop="companyName">
              <el-input disabled v-model="topData.companyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 业务部门 -->
            <el-form-item :label="$t('cooperation.label.departmentCode')" prop="departmentCode">
              <el-select v-model="topData.departmentCode" filterable @change="changeDepartment">
                <el-option
                  v-for="item in departmentList"
                  :key="item.personDepartmentCode"
                  :label="item.personDepartmentName"
                  :value="item.personDepartmentCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 申请时间 -->
            <el-form-item :label="$t('cooperation.label.requestTime')" prop="requestTime">
              <el-input disabled v-model="topData.requestTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 供应链主体编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('supplyChain.label.supplierCode')" prop="supplierCode">
              <el-input disabled v-model="topData.supplierCode"></el-input>
            </el-form-item>
          </el-col>
          <!-- 供应链主体名称 -->
          <el-col :span="6">
            <!-- 中文名 -->
            <el-tooltip
              :disabled="!topData.supplierName"
              class="item"
              effect="dark"
              :content="String(topData.supplierName)"
              placement="top"
            >
              <el-form-item
                class="textOver"
                :label="$t('supplyChain.label.supplierName')"
                prop="supplierName"
              >
                <!-- <el-input
                :disabled="isExtend"
                v-model="topData.supplierName" 
                :placeholder="$t('cooperation.placeholder.zh')" 
                @change="searchPartner(topData.supplierName)" clearable maxlength="32"></el-input> -->
                <search-table
                  v-model="topData.supplierName"
                  searchType="partnerNoFilter"
                  :extraData="{
                    departmentCode: topData.departmentCode,
                  }"
                  :isMultiple="true"
                  :currentValue="topData.supplierName || null"
                  :checkRowKeys="[topData.supplierCode]"
                  @input="setSupplier"
                ></search-table>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="12">
            <!-- 英文名 -->
            <el-tooltip
              :disabled="!topData.partnerEnName"
              class="item"
              effect="dark"
              :content="String(topData.partnerEnName)"
              placement="top"
            >
              <el-form-item :label="$t('cooperation.label.partnerEnName')" prop="partnerEnName">
                <el-input
                  disabled
                  :placeholder="$t('cooperation.placeholder.en')"
                  v-model="topData.partnerEnName"
                  clearable
                  maxlength="32"
                ></el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <!-- 创建人 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.createBy')" prop="requestCreatePersonNo">
              <el-select disabled v-model="topData.requestCreatePersonNo" clearable filterable>
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 申请人 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.requestBy')" prop="extendRequestPersonNo">
              <!-- <el-select clearable v-model="topData.extendRequestPersonNo" filterable>
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id">
                </el-option>
              </el-select> -->
              <search-table
                v-model="topData.extendRequestPersonNo"
                searchType="personnel"
                :isMultiple="true"
                :currentValue="topData.extendRequestPersonName || null"
                :checkRowKeys="[topData.extendRequestPersonNo]"
                @input="setRequestPerson"
              ></search-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs class="addSupplyChain" type="border-card" v-model="activeNameTab">
      <!-- 基本数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.baseData')" name="baseData">
        <div class="baseData">
          <el-form disabled :model="baseData" :rules="rules" ref="baseData" label-width="105px">
            <el-row :gutter="24">
              <!-- 统一社会信用代码 -->
              <el-col :span="6">
                <el-form-item
                  class="textOver"
                  :label="$t('cooperation.label.creditCode')"
                  prop="creditCode"
                >
                  <el-input v-model="baseData.creditCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 法人 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.legalPerson')" prop="legalPerson">
                  <el-input v-model="baseData.legalPerson" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 搜索简码 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.searchCode')" prop="searchCode">
                  <el-input v-model="baseData.searchCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 成立日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.establishedDate')"
                  prop="establishedDate"
                >
                  <el-date-picker
                    v-model="baseData.establishedDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 开票地址 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoiceAddress')" prop="invoiceAddress">
                  <el-input v-model="baseData.invoiceAddress" clearable maxlength="64"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票电话 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoicePhone')" prop="invoicePhone">
                  <el-input v-model="baseData.invoicePhone" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行名称 -->
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankName')"
                  prop="invoiceBankName"
                >
                  <el-input v-model="baseData.invoiceBankName" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行账号 -->
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankAccount')"
                  prop="invoiceBankAccount"
                >
                  <el-input
                    v-model="baseData.invoiceBankAccount"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 发票类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxType')" prop="taxType">
                  <el-select v-model="baseData.taxType" clearable filterable>
                    <el-option
                      v-for="item of taxTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 注册资本 -->
              <el-col :span="6">
                <el-row :gutter="24">
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('cooperation.label.registeredAssets')"
                      prop="registeredAssets"
                    >
                      <el-input
                        v-model="baseData.registeredAssets"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="currencyType">
                      <el-select
                        filterable
                        v-model="baseData.currencyType"
                        :placeholder="$t('cooperation.placeholder.currencyType')"
                        clearable
                      >
                        <el-option
                          v-for="item of tradeCurrencyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 交易币种 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.tradeCurrency')" prop="tradeCurrency">
                  <el-select filterable v-model="baseData.tradeCurrency" clearable>
                    <el-option
                      v-for="item of tradeCurrencyList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 企业类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.enterpriseType')" prop="enterpriseType">
                  <el-select v-model="baseData.enterpriseType" clearable filterable>
                    <el-option
                      v-for="item of enterpriseTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 省份/城市 -->
              <el-col :span="6">
                <el-row :gutter="24">
                  <el-col :span="16" style="padding-right: 0">
                    <el-form-item :label="$t('cooperation.label.province')" prop="province">
                      <el-select filterable v-model="baseData.province" clearable>
                        <el-option
                          v-for="item of provinceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="city">
                      <el-select filterable v-model="baseData.city" clearable>
                        <el-option
                          v-for="item of cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 街道地址/门牌号 -->
              <el-col :span="12">
                <el-row :gutter="24">
                  <el-col :span="20" style="padding-right: 0">
                    <el-form-item
                      :label="$t('cooperation.label.streetAddress')"
                      prop="streetAddress"
                    >
                      <el-input
                        v-model="baseData.streetAddress"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item class="isShowLabel" prop="roomNo">
                      <el-input v-model="baseData.roomNo" clearable maxlength="32"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.postCode')" prop="postCode">
                  <el-input v-model="baseData.postCode" clearable maxlength="32"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 备注 -->
              <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                <el-input v-model="baseData.mark" clearable maxlength="80"></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
        <!-- 银行数据表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="banks"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.banks"
            :columns="bankColumnList"
            :edit-rules="bankTableEditRules"
            :valid-config="{ message: 'default' }"
            :toolbar="{}"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="$refs.banks.commitProxy('insert_actived')"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('banks')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
        <!-- 联系人表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="contactPersons"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.contactPersons"
            :columns="linkColumnList"
            :toolbar="{}"
            :edit-rules="linkTableEditRules"
            :valid-config="{ message: 'none' }"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="$refs.contactPersons.commitProxy('insert_actived')"
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.add') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('contactPersons')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
        <!-- 上传附件表格 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="attachments"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="baseData.attachments"
            :columns="fileColumnList"
            :toolbar="{}"
            @cell-dblclick="ossClick"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="handleImportFile"
                type="primary"
                icon="el-icon-upload"
                class="vxe-btn-primary"
                >{{ $t('cooperation.buttons.importFile') }}</vxe-button
              >
              <vxe-button
                @click="handleDelete('attachments')"
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                >{{ $t('cooperation.buttons.delete') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
      <!-- 销售数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.salesData')" name="salesData">
        <sales-data ref="salesData" />
      </el-tab-pane>
      <!-- 采购数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.purchasingData')" name="purchasingData">
        <purchasing-data ref="purchasingData" />
      </el-tab-pane>
    </el-tabs>
    <footer class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050815384808744']"
        class="fixed-bottom-btn"
        type="primary"
        @click="handleValid('ZT06')"
        >{{ $t('cooperation.buttons.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815385735531']"
        class="fixed-bottom-btn"
        type="primary"
        @click="handleValid('ZT02')"
        >{{ $t('cooperation.buttons.submit') }}</el-button
      >
    </footer>
    <!-- 合作伙伴列表弹窗 -->
    <partner-list
      ref="partnerList"
      @getPartner="getPartner"
      @clearSupplierName="clearSupplierName"
      @handleExtend="handleExtend"
    />
    <!-- 扩展弹窗 -->
    <expand
      ref="expand"
      :extendRequestDepartmentList="departmentList"
      @deleteSupplierName="deleteSupplierName"
    />
    <!-- 上传 -->
    <sirui-upload
      :data="ossData"
      :action="ossUrl"
      fileList=".xls,.xlsx"
      ossSuccess="ossSuccess"
      ref="siruiUpload"
    >
    </sirui-upload>
    <!-- 上传 -->
    <el-upload
      v-show="false"
      accept=".xls,.xlsx"
      :data="ossData"
      :show-file-list="false"
      :with-credentials="true"
      :action="ossUrl"
      :before-upload="ossBefore"
      :on-success="ossSuccess"
      :on-error="ossError"
    >
      <el-button ref="uploadBtn" size="small" type="primary">{{
        $t('cooperation.buttons.clickImport')
      }}</el-button>
    </el-upload>
  </div>
</template>

<script>
  // import baseForm from '@/components/form/base-form';
  import API from '@/api/masterData/supplyChain';
  import DataBaseAPI from '@/api/dataBase';
  import { mapState } from 'vuex';
  import { dateFormat } from '@/filters';
  import { topDataRules } from './rules/rules';
  import { bankTableEditRules, linkTableEditRules } from './rules/tableRules.js';
  import partnerList from './dialog/partnerList';
  import salesData from './components/salesData';
  import purchasingData from './components/purchasingData';
  import Expand from './dialog/expand';
  import SearchTable from '@/components/form-item/search-table';
  import siruiUpload from '@/components/SiruiUpload';
  // import DictSelect from '@/components/DictSelect';
  // import { getCurrency } from '@/common/js/baseRequest';
  import { toFormErrorTop } from '@/common/js/util';
  import baseUrl from '@/common/config';
  export default {
    name: 'addSupplyChain',
    components: {
      SearchTable,
      siruiUpload,
      partnerList,
      salesData,
      purchasingData,
      Expand,
      // baseForm,
      // DictSelect,
    },
    computed: {
      //顶部表单配置
      options() {
        // const data = this.topData;
        return [
          {
            type: 'input',
            label: this.$t('cooperation.label.companyCode'),
            prop: 'companyCode',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.companyName'),
            prop: 'companyName',
            disabled: true,
          },
          {
            type: 'select',
            label: this.$t('cooperation.label.departmentCode'),
            prop: 'departmentCode',
            options: this.departmentList,
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.requestTime'),
            prop: 'requestTime',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('supplyChain.label.supplierCode'),
            prop: 'supplierCode',
            disabled: true,
          },
          {
            type: 'input',
            label: this.$t('supplyChain.label.supplierName'),
            prop: 'supplierName',
            disabled: this.isExtend,
            placeholder: this.$t('cooperation.placeholder.zh'),
            clearable: true,
            maxlength: '32',
            moreInput: true,
            moreProp: 'partnerEnName',
            moreDisabled: false,
            morePlaceholder: this.$t('cooperation.placeholder.en'),
          },
          {
            type: 'select',
            label: this.$t('cooperation.label.createBy'),
            prop: 'requestCreatePersonNo',
            disabled: true,
            options: this.requestByList,
          },
          {
            type: 'select',
            label: this.$t('cooperation.label.requestBy'),
            prop: 'extendRequestPersonNo',
            disabled: false,
            options: this.requestByList,
          },
        ];
      },
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            type: 'input',
            label: this.$t('cooperation.label.creditCode'),
            prop: 'creditCode',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.legalPerson'),
            prop: 'legalPerson',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.searchCode'),
            prop: 'searchCode',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'date',
            label: this.$t('cooperation.label.establishedDate'),
            prop: 'establishedDate',
            disabled: false,
            clearable: true,
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.invoiceAddress'),
            prop: 'invoiceAddress',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.invoicePhone'),
            prop: 'invoicePhone',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.invoiceBankName'),
            prop: 'invoiceBankName',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.invoiceBankAccount'),
            prop: 'invoiceBankAccount',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'dict',
            label: this.$t('cooperation.label.taxType'),
            prop: 'taxType',
            disabled: false,
            clearable: true,
            dictType: 'tax_type',
          },
          {
            type: 'select',
            label: this.$t('cooperation.label.registeredAssets'),
            prop: 'currencyType',
            options: this.currencyOptions,
            placeholder: this.$t('cooperation.placeholder.currencyType'),
            disabled: false,
            clearable: true,
            maxlength: '32',
            moreInput: true,
            moreProp: 'registeredAssets',
            moreClearable: true,
            moreMaxlength: '32',
            moreDisabled: false,
          },
          {
            type: 'dict',
            label: this.$t('cooperation.label.tradeCurrency'),
            prop: 'tradeCurrency',
            filterable: true,
            disabled: false,
            clearable: true,
            dictType: 'trade_currency',
          },
          {
            type: 'dict',
            label: this.$t('cooperation.label.enterpriseType'),
            prop: 'enterpriseType',
            disabled: false,
            clearable: true,
            dictType: 'enterprise_type',
          },
          {
            type: 'dict',
            label: this.$t('cooperation.label.province'),
            prop: 'province',
            disabled: false,
            clearable: false,
            dictType: 'province',
            moreSelect: true,
            moreProp: 'city',
            moreOptions: this.cityList,
            morePlaceholder: this.$t('cooperation.placeholder.city'),
            moreClearable: true,
            moreDisabled: false,
          },
          {
            span: 12,
            type: 'input',
            label: this.$t('cooperation.label.streetAddress'),
            prop: 'streetAddress',
            disabled: false,
            clearable: true,
            maxlength: '32',
            moreInput: true,
            moreClearable: true,
            moreProp: 'roomNo',
            morePlaceholder: this.$t('cooperation.placeholder.roomNo'),
            moreDisabled: false,
          },
          {
            type: 'input',
            label: this.$t('cooperation.label.postCode'),
            prop: 'postCode',
            disabled: false,
            clearable: true,
            maxlength: '32',
          },
          {
            type: 'textarea',
            label: this.$t('cooperation.label.mark'),
            prop: 'mark',
            span: 24,
            disabled: false,
            clearable: true,
            maxlength: '80',
          },

          /* searchTable样例 */
          /*    {
          type: 'searchTable', // 仓库
          prop: 'saleStorageCode',
          isMultiple: true,
          label: this.$t('departmentBusinessAdd.sellWareHouse'),
          searchType: 'warehouse',
          required: true, 
          name: 'saleStorageName',
          code: 'saleStorageCode',
          getName: 'storageName',
          getCode: 'storageCode',
        }, */
        ];
      },
      bankColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'bankName',
            title: this.$t('cooperation.label.bankName'),
            showHeaderOverflow: true,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bank"
                    isMultiple={true}
                    currentValue={row['bankName']}
                    checkRowKeys={[row['bankName']]}
                    onInput={(val) => this.chooseTable(val, row)}
                  ></search-table>,
                ];
              },
            },
          },
          // { field: "bankName", title: this.$t('cooperation.label.bankName'), editRender: { name: "ElInput",props: {clearable:true} } },
          {
            field: 'bankCode',
            title: this.$t('cooperation.label.bankCode'),
            /* 自定义列为select组件样例 */
            /* editRender: {
            name: 'ElSelect', 
            options: this.currencyOptions, 
            events: {change: this.currencyChangeEvent}
          }, */
            /* 自定义列为dict-select字典选择组件样例 */
            /* editRender: { name: "ElInput",props: {clearable:true}  },
          slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span>{ row.bankCode}</span>
              ]
            },
            edit: ({ row }) => {
              return [
                <dict-select
                  placeholder="this.$t('applicationDetail.baseForm.statusFlag')" 
                  type="cl-status-flag"
                  v-model="row.bankCode"
                  onChange={val => this.currencyChangeEvent(val, row)}
                ></dict-select>
              ]
            }
          } */
          },
          {
            field: 'associatedLineNumber',
            title: this.$t('cooperation.label.associatedLineNumber'),
            // editRender: { name: "ElInput",props: {clearable:true} }
          },
          {
            field: 'accountBankBranch',
            title: this.$t('cooperation.label.accountBankBranch'),
          },
          {
            field: 'bankAccount',
            title: this.$t('cooperation.label.bankAccount'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'contactPersonName',
            title: this.$t('cooperation.label.contactPersonName'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mobilePhone',
            title: this.$t('cooperation.label.mobilePhone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'telephone',
            title: this.$t('cooperation.label.telephone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'faxNo',
            title: this.$t('cooperation.label.faxNo'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'email',
            title: this.$t('cooperation.label.email'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'address',
            title: this.$t('cooperation.label.address'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      fileColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { field: 'attachmentName', title: this.$t('cooperation.label.attachmentName') },
          { field: 'createBy', title: this.$t('upload.uploader') },
          { field: 'gmtCreate', title: this.$t('upload.uploadDate') },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 省
        provinceList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'province').dictList;
          }
        },
        //是否
        yesnoList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'isAnotherPay').dictList;
          }
        },
      }),
    },
    data() {
      let newDate = dateFormat(new Date());
      return {
        activeNameTab: 'baseData',
        todayDate: newDate,
        isExtend: false, // 是否为扩展数据
        departmentList: [], // 部门数据
        requestByList: [], // 人员数据
        taxTypeList: [], // 发票类型数据
        enterpriseTypeList: [], // 企业类型数据
        tradeCurrencyList: [], // 交易币种数据
        postCodeList: [], // 邮政编码数据
        cityList: [], // 城市数据
        partnerDetail: {}, // 合作伙伴详情
        topData: {
          companyCode: '', // 公司代码
          companyName: '', // 公司名称
          departmentCode: '', // 业务部门
          departmentName: '', //部门名称
          requestTime: dateFormat(new Date()), // 申请时间
          supplierCode: '', // 供应链主体编码
          supplierName: '', // 供应链主体名称中文
          partnerEnName: '', // 供应链主体名称英文
          requestCreatePersonName: '', // 当前用户/创建人name
          requestCreatePersonNo: '', // 当前用户/创建人code
          extendRequestPersonNo: '', // 申请人code
        },
        baseData: {
          creditCode: '',
          legalPerson: '',
          establishedDate: '',
          invoiceAddress: '',
          invoicePhone: '',
          invoiceBankName: '',
          invoiceBankAccount: '',
          taxType: '',
          registeredAssets: '',
          currencyType: '',
          searchCode: '',
          tradeCurrency: '',
          postCode: '', // 邮政编码
          province: '', // 省份
          city: '', // 城市
          streetAddress: '', // 街道地址
          roomNo: '', // 门牌号
          mark: '', // 备注
          banks: [], // 银行表格
          contactPersons: [], // 联系人表格
          attachments: [], // 附件表格
        },
        rules: {},
        topDataRules: topDataRules,
        bankTableEditRules: bankTableEditRules, // 银行表格校验规则
        linkTableEditRules: linkTableEditRules, // 联系人校验规则
        ossUrl: '', // 附件上传地址
        ossData: {}, // 附件上传参数
        supplierValue: [], //判断是否选择供应链
        currencyOptions: [], //币别主数据
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.getDictList();
      });
      this.getData();
      this.getOssUrl();
    },

    methods: {
      currencyChangeEvent(val, row) {
        console.log(val, row);
        //row为该行数据时（dict-select等）变更row值则刷新该行数据
        //row不为该行数据时（ElSelect等），需要变更val中的row值达到刷新数据的效果
      },
      // 部门变更
      changeDepartment() {
        this.topData.supplierCode = '';
        this.topData.supplierName = '';
        this.topData.partnerEnName = '';
      },
      //基本数据表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'province') {
          this.baseData.city = !value.province ? this.baseData.city : '';
          value = value.province || this.baseData.province;
          this.$axios.post(DataBaseAPI.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
            if (res.data.code === 0) {
              this.cityList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        }
      },
      //获取值
      chooseTable(val, row) {
        row.bankName = val[0].bankName || '-';
        row.bankCode = val[0].bankCode || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.accountBankBranch = val[0].bankBranch || '-';
      },
      // 初始化数据
      getData() {
        this.topData.companyCode = this.userInfo.companyCode;
        this.topData.companyName = this.userInfo.companyName;
        this.topData.departmentCode = this.userInfo.departmentCode;
        this.topData.departmentName = this.userInfo.departmentName;
        this.topData.requestCreatePersonName = this.userInfo.userName;
        this.topData.requestCreatePersonNo = Number(this.userInfo.userCode);
        this.topData.extendRequestPersonNo = Number(this.userInfo.userCode);
        this.topData.extendRequestPersonName = this.userInfo.userName;
      },
      // 查询合作伙伴(已改为setSupplier())
      // searchPartner(e) {
      //   this.supplierValue=[];
      //   let params = {
      //     adminFlag: this.userInfo.adminFlag,
      //     // createBy: this.userInfo.userCode,
      //     departmentCodes: this.userInfo.departmentCode,
      //     selectView: "01",
      //     partnerName: e,
      //     requestStatus: "ZT03", // 已生效
      //   }
      //   this.loading.startLoading
      //   this.$axios.post(API.LIST_PARTNEREXTEND, params).then(res => {
      //    this.loading.endLoading();
      // 		if(res.data.code === 0) {
      //       if(res.data.data.length > 0) {
      // 			  this.$refs.partnerList.openDialog(res.data.data);
      //       } else {
      //         this.$refs.partnerList.handleClose()
      //         this.deleteSupplierName();
      //         this.$message({ showClose: true, message: this.$t('supplyChain.message.noData'), type: "error" });
      //       }
      // 		}
      // 	})
      // },
      // 取消新增清空中文名称输入框
      clearSupplierName() {
        this.topData.supplierName = '';
      },
      // 扩展
      handleExtend(data) {
        this.$confirmAction(this.$t('supplyChain.message.isExtend'), '')
          .then(() => {
            // this.$refs.expand.openDialog(data[0]);
            let info = data[0];
            let companyInfo = {
              companyName: this.userInfo.companyName,
              companyCode: this.userInfo.companyCode,
              departmentName: info.departmentName,
              departmentCode: info.departmentCode,
            };
            let propsPartnerData = {
              id: info.id,
              supplierCode: info.supplierCode,
              supplierName: info.supplierName,
            };
            this.$refs.expand.openDialog(propsPartnerData, '', companyInfo);
          })
          .catch(() => {
            this.deleteSupplierName();
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      // 取消扩展 => 删除名称
      deleteSupplierName() {
        this.topData.supplierName = '';
        this.topData.partnerEnName = '';
      },
      // 获取合作伙伴详情
      getPartner(value) {
        this.supplierValue = value;
        let params = {
          id: value.id,
        };
        this.$axios.get(API.GET_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            this.partnerDetail = res.data.data;
            const formList = ['baseData'];
            formList.forEach((el) => {
              Object.keys(this[el]).forEach((item) => {
                this[el][item] = res.data.data[item];
              });
            });
            this.baseData.banks = this.partnerDetail.partnersBanks;
            this.baseData.contactPersons = this.partnerDetail.partnersPersons;
            this.baseData.attachments = this.partnerDetail.partnersAttachments || [];
            this.topData.supplierName = res.data.data.partnerZhName;
            this.topData.partnerEnName = res.data.data.partnerEnName;
            this.baseData.enterpriseType = res.data.data.enterpriseType;
            if (this.partnerDetail.province)
              this.handleChangeBaseData(this.partnerDetail.province, 'province');
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      // 校验 => 提交
      handleValid(type) {
        // 判断是否只输入供应链名称，没有选择合作伙伴，直接提交
        if (this.supplierValue.length == 0) {
          this.topData.supplierName = '';
        }
        // 顶部表单校验
        const topDataValid = new Promise((resolve, reject) => {
          this.$refs.topData.validate((valid) => {
            if (valid) {
              resolve(this.topData);
            } else {
              reject('topData');
              toFormErrorTop();
            }
          });
        });
        // 银行表格校验
        const banks = new Promise((resolve, reject) => {
          this.$refs.banks.validate((valid) => {
            if (valid) {
              resolve(this.baseData.banks);
            } else {
              reject('banks');
              toFormErrorTop();
              this.$message({ showClose: true, type: 'error', message: '请将银行表格填写完整' });
            }
          });
        });
        // 联系人表格校验
        const contactPersons = new Promise((resolve, reject) => {
          this.$refs.contactPersons.validate((valid) => {
            if (valid) {
              resolve(this.baseData.contactPersons);
            } else {
              toFormErrorTop();
              reject('contactPersons');
              this.$message({
                showClose: true,
                type: 'error',
                message: '请将联系人表格填写完整',
              });
            }
          });
        });
        const list = [
          topDataValid,
          banks,
          contactPersons,
          this.$refs.salesData.returnData(),
          this.$refs.purchasingData.returnData(),
        ];
        Promise.all(list)
          .then((result) => {
            // 校验通过
            this.handleSave(result, type);
          })
          .catch((err) => {
            if (err == 'baseData' || err == 'salesData' || err == 'purchasingData') {
              this.activeNameTab = err;
            } else {
              this.activeNameTab = 'baseData';
            }
            toFormErrorTop();
          });
      },
      // 保存
      handleSave(result, type) {
        this.loading.startLoading();
        let params = Object.assign(result[0], this.baseData);
        params = Object.assign(params, result[3]);
        params = Object.assign(params, result[4]);
        params.isSubmit = type == 'ZT06' ? '2' : '1';
        params.adminFlag = this.userInfo.adminFlag;
        params.partnerCode = this.partnerDetail.partnerCode;
        params.tenantCode = this.userInfo.tenantCode;
        params.extendRequestPersonName = this.userInfo.userName;
        params.supplierCompanyNo = params.companyCode;
        params.supplierCompanyName = params.companyName;
        params.extendRequestDepartmentNo = params.departmentCode;
        params.extendRequestDepartmentName = params.departmentName;
        params.banks = this.$refs.banks.getTableData().fullData;
        params.contactPersons = this.$refs.contactPersons.getTableData().fullData;
        params.attachments = this.$refs.attachments.getTableData().fullData;
        params.supplierPartners = [...params.customerList, ...params.serviceList];
        delete params.requestTime;
        this.$axios.post(API.ADD_SUPPLIER, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            if (type == 'ZT06') {
              this.dblclickEvent(res.data.data);
            } else {
              this.returnPath();
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //返回详情
      dblclickEvent(value) {
        let propData = {
          departmentCode: value.departmentCode,
          id: value.id,
          supplierCode: value.supplierCode,
        };
        let path = {
          fromPath: {
            path: '/masterData/addSupplyChain',
            name: 'addSupplyChain',
            meta: {
              keepAlive: true,
              title: '',
            },
          },
          toPath: {
            path: '/masterData/editSupplyChain',
            name: 'editSupplyChain',
            meta: {
              keepAlive: false,
              title: this.$t('supplyChain.router.edit'),
            },
            query: {
              propData: JSON.stringify(propData),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/masterData/addSupplyChain',
            name: 'addSupplyChain',
            meta: {
              keepAlive: true,
              title: '',
            },
          },
          toPath: {
            path: '/masterData/supplyChain',
            name: 'supplyChain',
            meta: {
              keepAlive: false,
              title: this.$t('supplyChain.router.list'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //申请人
      setRequestPerson(row) {
        this.topData.extendRequestPersonNo = row ? row[0].id : null;
        this.topData.extendRequestPersonName = row ? row[0].personName : null;
      },
      setSupplier(row) {
        this.supplierValue = row;
        this.clearSupplierName();
        console.log(row);
        const params = {
          partnerCode: row[0].partnerCode,
          adminFlag: this.userInfo.adminFlag,
          checkFlag: '1',
          departmentCode: this.userInfo.departmentCode,
        };
        console.log(params);
        // 本部门查重
        this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
          this.clearSupplierName();
          if (res.data.code === 0) {
            if (res.data.data.length === 0) {
              delete params.departmentCode;
              // 全公司查重
              this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
                this.clearSupplierName();
                if (res.data.code === 0) {
                  if (res.data.data.length == 0) {
                    this.getPartner(row[0]);
                  } else {
                    this.handleExtend(res.data.data);
                  }
                }
              });
            } else {
              console.log('报错：' + this.topData.supplierName);
              this.$message({
                showClose: true,
                message: this.$t('supplyChain.message.dataRepeat'),
                type: 'error',
              });
            }
          }
        });
      },
      // 导入文件
      handleImportFile() {
        this.$refs.uploadBtn.$el.click();
      },
      // 获取附件上传地址
      getOssUrl() {
        this.ossUrl = baseUrl + API.OSS_UPLOAD_API;
        // 附件上传参数
        this.ossData = {
          tenantCode: this.userInfo.tenantCode,
          access_token: this.userInfo.access_token,
        };
      },
      // 开始上传
      ossBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      ossSuccess(response, file) {
        this.loading.endLoading();
        if (response.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t('bank.message.importSuccess'),
            type: 'success',
          });
          let fileObj = {
            attachmentName: file.name,
            attachmentPath: file.response.data,
            createBy: this.userInfo.userName,
            gmtCreate: this.todayDate,
          };
          this.baseData.attachments.push(fileObj);
        } else {
          if (response.data) {
            window.location.href = `${response.data}`;
          }
          this.$message({ showClose: true, message: response.msg, type: 'error' });
        }
      },
      // 上传错误
      ossError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 附件双击下载
      ossClick(data) {
        window.location.href = data.row.attachmentPath;
      },
      // 获取字典值
      getDictList() {
        const tenantCode = this.userInfo.tenantCode;
        // 获取部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            let list = res.data.data.personDepartmentInfo;
            if (list.length > 0) {
              this.departmentList = list.map((item) => {
                item['value'] = item.personDepartmentCode;
                item['label'] = item.personDepartmentName;
                return item;
              });
            }
          }
        });
        // 获取用户数据
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            this.requestByList = res.data.data.personInfo;
          }
        });
        // 发票类型
        this.$axios
          .post(API.DICT_LIST, { dictType: 'tax_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.taxTypeList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 企业类型
        this.$axios
          .post(API.DICT_LIST, { dictType: 'enterprise_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.enterpriseTypeList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 交易币种
        this.$axios.get(API.LIST_CURRENCY).then((res) => {
          if (res.data.code === 0) {
            this.tradeCurrencyList = [];
            if (res.data.data.length > 0) {
              res.data.data.forEach((item) => {
                let obj = {
                  label: item.currencyName,
                  value: item.currencyCode,
                };
                this.tradeCurrencyList.push(obj);
              });
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 邮政编码
        this.$axios
          .post(API.DICT_LIST, { dictType: 'post_code', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.postCodeList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 城市
        this.$axios
          .post(API.DICT_LIST, { dictType: 'city', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.cityList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 获取币别
        this.$baseRequest.getCurrency().then((res) => {
          this.tradeCurrencylist = [];
          if (res.length > 0) {
            this.currencyOptions = res.map((item) => {
              item['value'] = item.currencyCode;
              item['label'] = item.currencyName;
              return item;
            });
          }
        });
      },
    },
  };
</script>
<style>
  .addSupplyChain .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }
  .addSupplyChain .textOver label {
    line-height: unset;
  }
  .addSupplyChain .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped>
  .addSupplyChain {
    padding-bottom: 100px;
  }
  .addSupplyChain .el-select,
  .el-input {
    width: 100%;
  }
</style>
